<template>
  <v-text-field
    v-model="title"
    class="mx-2"
    :label="label"
    hide-details
    outline
    height="44"
    :readonly="true"
    :rules="rules"
  />
</template>

<script>
import { getWarehouseLoadingPlaceReference } from "../../../backend/warehouseApi.js";
export default {
  props: ["value", "label", "warehouseId", "rules"],
  data() {
    return {
      title: null,
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.title = val.title;
        }
      },
      immediate: true,
    },
    warehouseId: {
      handler(val) {
        if (val !== 0) {
          this.getWarehouseAddress();
        }
        if (!val) {
          this.title = null;
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getWarehouseAddress() {
      const warehouseAddress = await getWarehouseLoadingPlaceReference(
        this.warehouseId,
      );
      this.title = warehouseAddress.title;
      this.$emit("input", warehouseAddress);
    },
  },
};
</script>
